<template>
    <div class="px-3 py-2">
        <div class="relative p-10 overflow-hidden bg-white shadow dark:bg-neutral-950">
            <icon
                v-if="last && last.success"
                icon="hero/solid/check-circle"
                class="absolute top-0 left-0 z-0 -mt-8 -ml-8 text-green-100 size-64 dark:text-green-950"
            ></icon>
            <icon
                v-else-if="last && !last.success"
                icon="hero/solid/x-circle"
                class="absolute top-0 left-0 z-0 -mt-8 -ml-8 text-red-100 size-64 dark:text-red-950"
            ></icon>
            <icon
                v-else
                icon="hero/solid/ellipsis-horizontal-circle"
                class="absolute top-0 left-0 z-0 -mt-8 -ml-8 text-neutral-100 size-64 dark:text-red-950"
            ></icon>
            <div class="relative grid gap-5 z-1 lg:grid-cols-2">
                <div class="space-y-4" :class="[loading.stats ? 'animate-pulse' : '']">
                    <div v-if="lastSuccessful" class="text-xs">
                        {{
                            lang('events::sync.status.last', {
                                date: dateTimeHumanReadableWithoutYearFromISO(lastSuccessful.created_at),
                            })
                        }}
                        ({{ relativeTime(lastSuccessful.created_at) }})
                    </div>
                    <div
                        v-if="last"
                        class="p-2 mt-2 text-xs text-center rounded-md"
                        :class="[
                            last.success
                                ? 'border border-green-500 dark:border-green-800 bg-green-500 text-green-950 dark:bg-green-800 dark:text-green-50'
                                : 'border border-neutral-500 dark:border-neutral-800 bg-neutral-500 text-neutral-950 dark:bg-neutral-800 dark:text-neutral-50',
                        ]"
                    >
                        {{
                            last.success
                                ? lang('events::sync.status.last_success')
                                : lang('events::sync.status.last_failure')
                        }}
                    </div>
                </div>
                <div class="flex items-center justify-center py-6 bg-neutral-100 dark:bg-neutral-800">
                    <Button dusk="grid-sync" color="primary" :loading="loading.sync" @click="sync">
                        {{ lang(`events::sync.actions.sync`) }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { dateTimeHumanReadableWithoutYearFromISO, relativeTime } from '@src/Common/Helpers/dates';
import { ApiResponse } from '@src/Common/DataGrid/types';
import { useToast } from '@src/Common/Composables/useToast';

const { props } = usePage();

const page = ref(props.components[0] ?? null);

const last = ref(null);
const lastSuccessful = ref(null);

const loading = ref({
    stats: false,
    sync: false,
});

const load = () => {
    loading.value.stats = true;

    axios.get(page.value.route).then(({ data }) => {
        last.value = data.last;
        lastSuccessful.value = data.lastSuccessful;
        loading.value.stats = false;
    });
};

load();

const sync = () => {
    loading.value.sync = true;

    axios
        .post(route('events/sync.admin.api.sync'))
        .then(({ data }: ApiResponse) => {
            useToast({ message: data.message, type: data.success ? 'success' : 'error' });
        })
        .finally(() => {
            loading.value.sync = false;
            load();
        });
};
</script>
